export const API = {

    SEARCH_ITEMS: "/Dispatch/getItems",
}